import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, inject } from '@angular/core';
import { EvSpinnerComponent } from '../components/ev-spinner.component';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private overlay = inject(Overlay);


  overlayRef: OverlayRef

  private getSpinner() {
    return $('.loading');
  }

  show() {

    this.hide()

    this.overlayRef = this.overlay.create({
      hasBackdrop: true, positionStrategy:
        this.overlay.position().global().centerHorizontally().centerVertically()
    })
    const userProfilePortal = new ComponentPortal(EvSpinnerComponent)
    this.overlayRef.attach(userProfilePortal)
  }

  hide() {
    this.overlayRef?.dispose()
  }

}
